import { createFileRoute } from '@tanstack/react-router';

// Intentionally has no feature guard — gating this page would create a loop
// where users without the right flag get bounced away from the page that
// explains they don't have the right flag.
export const Route = createFileRoute('/_authenticated/not-available')({});
